import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/Voip/Destination';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {
        list: {},
        dropDownList: [],
        countriesAndOperatorsList: {},
        getDropDownSipList: []
    },
    actions: {
        async setTopDestination(context, params) {
            let divisionId = (params.divisionId)? ( "/" + params.divisionId) : ''

            let api = {
                verb: params.verb,
                service: moduleAjaxService,
                url: baseUrl + '/topDestination/' + params.destinationId + divisionId,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getTopDestination(context, params) {
            let divisionId = (params.divisionId)? ( "?division_id=" + params.divisionId) : ''
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/topDestination' + divisionId
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async topDestination(context, params) {
            let api = {
                verb: params.verb,
                service: moduleAjaxService,
                url: baseUrl + '/topDestination/' + params.destinationId,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/createOrFirst',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    context.state.dropDownList.push({value: r.data.id, label: r.data.country})
                    context.state.list.push({value: r.data.id, label: r.data.country})
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async resetRatesAndTests(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/resetRatesAndTests',
                data: AFD({}),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async resetDestinationRates(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/resetDestinationRates/' + params.divisionId + '/' + params.destinationId,
                data: AFD({}),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    context.commit('RESET_CACHE')
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    context.commit('RESET_CACHE')
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async get(context, params) {
            let page = (params.page)? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id + '?page=' + page
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async list (context, params) {
            let page = (params.page) ? params.page : 1
            let search = (params.hasOwnProperty('search'))? "&search=" + encodeURIComponent(params.search) : ''
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page + search,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async countriesAndOperatorsList (context, params) {
            let page = (params.page)? params.page : 1

            if (context.state.countriesAndOperatorsList[page] !== undefined) {
                return context.state.countriesAndOperatorsList[page]
            }

            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/countriesAndOperatorsList?page=' + page,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    context.state.countriesAndOperatorsList[page] = r.data
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDropDownSipList (context, params) {
            /*if (context.state.getDropDownLcrList.length) {
                return context.state.getDropDownSipList
            }*/

            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getDropDownSipList',
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    context.state.getDropDownSipList = r.data
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDropDownList (context, params) {
            if (context.state.dropDownList.length) {
                return context.state.dropDownList
            }

            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownList',
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    context.state.dropDownList = r.data
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDestinationRate (context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getDestinationRate/' + params.id + '/' + params.divisionId + ((params.vendor_id)? '/' + params.vendor_id : ''),
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDestinationRateSms (context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getDestinationRateSms/' + params.id + '/' + params.divisionId + ((params.vendor_id)? '/' + params.vendor_id : ''),
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDestinationMCCMNC (context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getDestinationMCCMNC/' + params.id + '/' + params.divisionId + ((params.vendor_id)? '/' + params.vendor_id : ''),
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDestinationRateByDialCode (context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getDestinationRateByDialCode/' + params.id + '/' + params.divisionId + ((params.vendor_id)? '/' + params.vendor_id : ''),
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, { root: true }).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        }
    },
    mutations: {
        RESET_CACHE (state, params) {
            state.list = {}
            state.dropDownList = []
            state.countriesAndOperatorsList = {}
        }
    }
};

export default api
